<nz-modal [(nzVisible)]="isVisible" nzTitle="Room Details" [nzMaskClosable]="false" (nzOnCancel)="handleCancel()"
  [nzFooter]="modalFooter" [nzWidth]="'90vw'" [nzStyle]="{ top: '40px' }">
  <ng-container *nzModalContent>
    <nz-descriptions nzBordered [nzColumn]="2" class="venue-room-descriptions">
      <nz-descriptions-item nzTitle="Room Name">
        {{ data?.room_name }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Room Type">
        {{ data?.room_type_name }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Max Capacity">
        {{ data?.max_capacity }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Room Length (m)">
        {{ data?.room_length }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Seating Capacity (Theatre)">
        {{ data?.seating_capacity_theatre }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Capacity - Long Table">
        {{ data?.capacity_long_table }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Capacity - Classroom">
        {{ data?.capacity_classroom }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Capacity - Boardroom">
        {{ data?.capacity_boardroom }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Capacity - Banquet Rounds">
        {{ data?.capacity_banquet_rounds }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Capacity - U Shape">
        {{ data?.capacity_u_shape }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Capacity - Reception/Standing">
        {{ data?.capacity_reception_standing }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Total Space (sq. m)">
        {{ data?.total_space }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Ceiling Height (ft.)">
        {{ data?.ceiling_height }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Natural Light">
        {{ data?.natural_light ? "Yes" : "No" }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Soundproofing">
        {{ data?.soundproofing ? "Yes" : "No" }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Room Specifications">
        {{ data?.room_specifications }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Breakout Rooms">
        {{ data?.breakout_rooms }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="In-house AV">
        {{ data?.in_house_av ? "Yes" : "No" }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Stage Availability">
        {{ data?.stage_availability ? "Yes" : "No" }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="LED Wall">
        {{ data?.led_wall }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="TV">
        {{ data?.tv ? "Yes (" + data?.tv_size + " inch)" : "No" }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Projector and Screen">
        {{
        data?.projector_and_screen
        ? "Yes (" + data?.screen_size + " inch)"
        : "No"
        }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Media Links">
        <ng-container *ngIf="mediaLinksDisplay.length; else noLinks">
          <div class="media-link" *ngFor="let link of mediaLinksDisplay">
            <a [href]="link" target="_blank" rel="noopener noreferrer">
              {{ link }}
            </a>
          </div>
        </ng-container>

        <ng-template #noLinks>
          <span class="no-links">No Media Available</span>
        </ng-template>
      </nz-descriptions-item>

    </nz-descriptions>
  </ng-container>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">Close</button>
  </ng-template>
</nz-modal>
